import { useEffect } from 'react';

// Stack of active modal close handlers to ensure only the topmost modal closes on Escape
const escapeHandlersStack = [];

if (typeof window !== 'undefined') {
  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' || event.key === 'Esc') {
      if (escapeHandlersStack.length > 0) {
        const topHandler = escapeHandlersStack[escapeHandlersStack.length - 1];
        topHandler(event);
      }
    }
  });
}

/**
 * Hook to register an Escape key handler for a modal or dialog.
 * @param {Function} onClose - Callback function executed when Escape is pressed.
 * @param {boolean} [isActive=true] - Whether the listener should be active (e.g. isOpen state).
 */
export const useEscapeKey = (onClose, isActive = true) => {
  useEffect(() => {
    if (!isActive || typeof onClose !== 'function') return;

    const handler = (e) => {
      onClose(e);
    };

    escapeHandlersStack.push(handler);

    return () => {
      const index = escapeHandlersStack.indexOf(handler);
      if (index !== -1) {
        escapeHandlersStack.splice(index, 1);
      }
    };
  }, [onClose, isActive]);
};

export default useEscapeKey;
